import { Component, OnDestroy } from '@angular/core'
import { Title, Meta } from '@angular/platform-browser'
import { SEOService } from '@flowaccount/landing'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'

@Component({
  selector: 'flowaccount-flowpay',
  templateUrl: './flowpay.component.html',
  styleUrls: ['./flowpay.component.scss'],
})
export class FlowpayComponent implements OnDestroy {
  private languageChangeSubscription: Subscription

  constructor(
    public translate: TranslateService,
    private seoService: SEOService,
    private titleService: Title,
    private meta: Meta,
  ) {
    this.setMeta()
    this.languageChangeSubscription = this.translate.onLangChange.subscribe(() => this.setMeta())
  }

  ngOnDestroy(): void {
    this.languageChangeSubscription?.unsubscribe()
  }

  private setMeta(): void {
    const title = this.translate.instant('metatitle-Function-flowpay')
    const description = this.translate.instant('metaDescription-flowpay')
    const image = 'https://flowaccountcdn.com/new_landing/image/functions/flowpay/FlowPay_og_image_v2.jpg'
    const canonicalUrl = 'https://flowaccount.com/functions/flowpay'

    this.titleService.setTitle(title)
    this.seoService.createMetaTag(title, description)
    this.seoService.createOg(image, title, description)
    this.seoService.setCanonicalUrl(canonicalUrl)
    this.meta.updateTag({ name: 'robots', content: 'index, follow' })
  }
}
